var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.775 3C2.071 3 1.5 3.5879 1.5 4.3125v8.75c0 .7246.571 1.3125 1.275 1.3125H3.2C3.2 15.8242 4.3422 17 5.75 17s2.55-1.1758 2.55-2.625h3.4c0 1.4492 1.1422 2.625 2.55 2.625s2.55-1.1758 2.55-2.625h.85c.4702 0 .85-.391.85-.875s-.3798-.875-.85-.875V9.4887c0-.4649-.178-.9106-.4967-1.2387L15.1 6.1363c-.3188-.3281-.7517-.5113-1.2033-.5113H12.55V4.3125C12.55 3.5879 11.9789 3 11.275 3zm9.775 4.375h1.3467L15.95 9.4887V10h-3.4zm-8.075 7c0-.3481.1343-.6819.3734-.9281.2392-.2461.5635-.3844.9016-.3844s.6624.1383.9016.3844c.239.2462.3734.58.3734.9281s-.1343.6819-.3734.9281c-.2392.2461-.5635.3844-.9016.3844s-.6624-.1383-.9016-.3844c-.239-.2462-.3734-.58-.3734-.9281m9.775-1.3125c.3382 0 .6625.1383.9016.3844s.3734.58.3734.9281-.1343.6819-.3734.9281c-.2391.2461-.5634.3844-.9016.3844s-.6625-.1383-.9016-.3844-.3734-.58-.3734-.9281.1343-.6819.3734-.9281c.2391-.2461.5634-.3844.9016-.3844"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/car.a5c42e9aa922b95440d5ca5558b72145.svg";